import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import GridItem from './GridItem';



const MultiInput = ({label,setInput,input,children,widthSize,minRows,maxRows,isRequired,maxLength})=>{
return(
	<GridItem>
		<TextField
			label={label}
			onChange={(e)=>{setInput(e?.target?.value)}}
            multiline={true}		
        	placeholder={`${label}...`}
			required={isRequired ? isRequired : false}
            maxRows={10}
			minRows={1}
			sx={{width:{xs:350,md:300,gridColumn: "span 2",fontSize:10}}}
			value={input}
			InputProps={{
				maxLength: maxLength ? maxLength : null,
				endAdornment: (
				<InputAdornment  style={{justifyContent:"center",textAlign:"left",padding:5}} position="end">
					{children}
				</InputAdornment>
				)
			}}
		/>		
	</GridItem>


)
}

export default MultiInput